































































































































































































import { Component, Ref, Watch } from "vue-property-decorator";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import Viewpoints from "@/store/modules/Viewpoints";
import Decisions from "@/store/modules/Decisions";
import Choices from "@/store/modules/Choices";
import { VIEWPOINT_API } from "@/api/ViewpointApi";
import { REQUIRED } from '@/rules';
import _ from "lodash";
import DescriptionEditor from "@/components/common/DescriptionEditor.vue";
import CardTitle from '@/components/common/CardTitle.vue';

const viewpointsModule = getModule(Viewpoints);
const choicesModule = getModule(Choices);
const decisionsModule = getModule(Decisions)

@Component({
    components: {DescriptionEditor, CardTitle}
})
export default class ChoiceScoreInputShareDialog extends Vue {
    private REQUIRED = REQUIRED

    private show = false;

    private selectedChoiceIndex: number = this.selectedChoiceIdIndex;
    private showBars = false;
    private viewpointIds: string[] = []
    private generatedLink: string | null = null;
    private copiedTooltip = false;
    private generating = false;
    private name: string = this.selectedDecision ? this.selectedDecision.name : '';
    private description: string = '';

    @Ref()
    private linkField: HTMLInputElement;

    get viewpointsList() {
        return _.sortBy((viewpointsModule.decisionViewpoints || []), 'name');
    }

    get selectedChoiceIdIndex() {
        return this.choiceList.findIndex(c => c.id === this.selectedChoiceId);
    }

    get selectedChoiceId() {
        return choicesModule.selectedChoiceId;
    }

    get choiceList() {
        return choicesModule.choicesList;
    }

    get choiceId(): string {
        if (this.selectedChoiceIndex >= 0 && this.choiceList[this.selectedChoiceIndex]) {
            return this.choiceList[this.selectedChoiceIndex].id;
        }
        return '';
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision
    }

    get singularViewpointLabel() {
        return decisionsModule.singularViewpointLabel;
    }

    get pluralViewpointLabel() {
        return decisionsModule.pluralViewpointLabel;
    }

    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel;
    }

    @Watch("show")
    onShowChange() {
        this.viewpointIds = [];
        this.generatedLink = null;
    }

    private async createShareLink() {
        if (!this.name) return;
        this.generating = true;
        let decisionId = getModule(Decisions).selectedDecisionId;
        if (!decisionId) return;

        // let viewpointIdsString = this.viewpointIds.sort().join('-');
        // let cookieKey = `csi-${this.choiceId}-${decisionId}-${viewpointIdsString}`;
        // if (this.$cookies.isKey(cookieKey)) {
        //     this.generatedLink = this.$cookies.get(cookieKey);
        // } else {
        let shareLinkData = await VIEWPOINT_API.generateScoreInputForm(decisionId, this.name, this.description, this.viewpointIds, this.choiceId, this.showBars);
        this.generatedLink = `http${window.location.hostname === 'localhost' ? '' : 's'}://${window.location.host}/input/choice/score?\&form=${shareLinkData.formId}`;
        //     this.$cookies.set(cookieKey, this.generatedLink);
        // }
        this.generating = false;
    }


    private copy() {
        this.copiedTooltip = true;
        setTimeout(() => this.copiedTooltip = false, 3000);
    }

    private viewpointListChange() {
        while (this.viewpointIds.length > 5) {
            this.viewpointIds.pop();
        }
    }

}
